import React from 'react';
import { Link } from 'react-router-dom';
import './CallToAction.css';

const CallToAction = ({ title, subtitle, buttonText, buttonLink }) => {
  return (
    <section className="cta">
      <div className="cta-container">
        <h2>{title}</h2>
        {subtitle && <p>{subtitle}</p>}
        {buttonText && buttonLink && (
          <Link to={buttonLink} className="btn">
            {buttonText}
          </Link>
        )}
      </div>
    </section>
  );
};

export default CallToAction; 